import { Reference } from '@apollo/client';
import * as graphql from 'generated/graphql';
import _ from 'lodash';
import { reactiveVariables } from 'modules/common';
import { ITypeSpecificPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/shared';



export const Query: ITypeSpecificPolicy<graphql.Query> = {
  fields: {
    isSuperAdmin: {
      read: () => {
        const isSuperAdmin = reactiveVariables.isLoggedInUserSuperAdmin();
        return isSuperAdmin === 'yes';
      }
    },

    authStatus: {
      read: (prev, { readField }) => {
        const loggedIn = reactiveVariables.isLoggedInVar();

        if (!loggedIn) {
          return 'signedOut';
        }

        const loggedInUser = readField<Reference>('loggedInUser');
        if (!loggedInUser) {
          return undefined;
        }
        return 'signedIn';
      }
    },



    companyContextCategories: {
      read: (existing: Reference[], { readField }) => {
        if (!existing) {
          return existing;
        }

        const toInclude = existing.filter((category) => {
          const name = readField<graphql.CompanyContextCategoryName>('name', category);
          return name && __questionContent2Index.has(name);
        });
        const sorted = _.sortBy(toInclude, (question) => {
          const name = readField<graphql.CompanyContextCategoryName>('name', question);
          if (!name) {
            return -1;
          }

          return __questionContent2Index.get(name) ?? -1;
        });

        return [...sorted];
      }
    }
  }

};



const __questionContent2Index = _.reduce([
  'quarterlyReports',
  'revenue',
  'margins',
  'costStructureAndEfficiency',
  'earnings',
  // search company data gets inserted here.
  'liquidity',
  'dividends',
  'valuation'
] as const, (map, question, index) => {
  map.set(question, index);
  return map;
}, new Map<graphql.CompanyContextCategoryName, number>());
